module.exports = __webpack_public_path__ + "images/pochta-bank-ff4dff49.png";